module.exports = __webpack_public_path__ + "static/img/resetIcon1.31ec24bd.png";